import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { Container, Row, Col } from "react-bootstrap";
import HelmetWrapper from "../../../HelmetWrapper";
import CommonStructured from "../../common-components/CommonStructured";
import CmnFilters from "../../lead-management/common/CmnFilters";
import MembershipPauseForm from "./MembershipPauseForm";
import PauseMembershipListings from "./PauseMembershipListings";
import { fetchMembershipPauseData } from "../../../redux/plans-reducers/plansSlice";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import ViewDetails from "./ViewDetails";
import { isManagerRole as checkIsManagerRole } from "../../common-data/Conversions";

const PauseMembershipStructure = ({ userInfoData }) => {
  const dispatch = useDispatch();

  const { planPauseLoading } = useSelector((state) => state.plans);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isManagerRole = checkIsManagerRole(userInfoData);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    selAddedby: "",
    selectedPlanDuration: "",
    isActive: "",
    leadAddDateFrom: "",
    leadAddDateTo: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters?.selectedGym?.value || "",
    plan_duration: allFilters?.selectedPlanDuration?.value || "",
    status: allFilters?.isActive?.value || "",
    added_by: allFilters?.selAddedby?.value || "",
    start_date: allFilters.leadAddDateFrom || "",
    end_date: allFilters.leadAddDateTo || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getAllPlanPause(filters = {}) {
    dispatch(
      fetchMembershipPauseData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedGym: !isAdmin
        ? {
            label: userInfoData?.name || userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    }));
  }, [userInfoData?.gym_id]);

  useEffect(() => {
    getAllPlanPause(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      plan_duration: allFilters.selectedPlanDuration?.value || "",
      status: allFilters.isActive?.value || "",
      added_by: allFilters.selAddedby?.value || "",
      start_date: allFilters.leadAddDateFrom || "",
      end_date: allFilters.leadAddDateTo || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selectedPlanDuration,
    allFilters.isActive,
    allFilters.selAddedby,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Membership Pause System">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Detail Modal"
          ariaHideApp={false}>
          <div
            className={`createNewCTOModalContainer ${
              modValues.modName === "view_details" ? "" : "mod-width-50p"
            }`}>
            {/* {modValues.modName === "remarks" ||
            modValues.modName === "view_details" ? ( */}
            <ModalHeadAndClose
              title={
                modValues.modName === "add"
                  ? "Membership Pause Form"
                  : modValues.modName === "view_details"
                  ? "Pause Details"
                  : modValues.modName?.replace(/_/g, " ")
              }
              onClose={onCloseModal}
            />
            {/* ) : null} */}

            {modValues.modName === "add" ? (
              <MembershipPauseForm
                userInfoData={userInfoData}
                closeModal={onCloseModal}
                callFunction={() => getAllPlanPause(filters)}
              />
            ) : modValues.modName === "remarks" ? (
              <div className="discussionModalMessage mt30">
                <p className="message">
                  {modValues.rowData?.description ||
                    modValues.rowData?.remark ||
                    "No Content Available"}
                </p>
              </div>
            ) : modValues.modName === "view_details" ? (
              <ViewDetails rowData={modValues.rowData} />
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Membership Pause System"}
              isReload={() => getAllPlanPause(filters)}
              createBtnTxt={"+ new membership pause"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "add",
                }))
              }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from={"membership-pause"}
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              isLoading={planPauseLoading}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <PauseMembershipListings
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              userInfoData={userInfoData}
              callFunction={() => getAllPlanPause(filters)}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default PauseMembershipStructure;
